<div class="container">
    <!-- Actividades Pendientes -->
    <section class="section">
        <div class="title-section mt-3">
            <div><h5>Filtros: Siempre | Mis actividades | Todos los tipos de actividad | Fechas más recientes</h5></div>
            <div class="title-buttons">
                <button class="btn btn-primary-outline" (click)="reload()">Actualizar</button>
                <button class="btn btn-primary-outline" (click)="openNewfilterActivities()">Filtrar actividades</button>
            </div>
        </div>
        <div class="section-header mt-3">
            <h2 class="section-title">
                <img src="assets/svg/plain-clock-icon.svg" alt="">
                Actividades pendientes
            </h2>
            <span class="chevron" (click)="toggleSection('pendientes')">
                <img src="assets/svg/arrow-down-black.svg"
                    [class.rotated]="sectionExpanded.pendientes"
                    alt="">
            </span>

        </div>
        <div *ngIf="t_pendientes.length === 0"><h4>No hay actividades pendientes</h4></div>

        <div class="timeline" *ngIf="sectionExpanded.pendientes">
            <article class="activity-item" *ngFor="let task of t_pendientes">
                <div class="activity-header">
                    <div class="activity-meta">
                        <span class="activity-date">{{(task.fecha_vencimiento | date:'d MMMM y':'':'es') | titlecase}}</span>
                        <a href="#" class="activity-assignee">
                            <img src="assets/svg/usert-icon.svg" alt="">
                            {{ task.ejecutivo.nombre }} {{ task.ejecutivo.apellido }}
                        </a>
                    </div>
                    <span class="activity-status status-pendiente">{{task.estado}}</span>
                </div>

                <div class="activity-card">
                    <div class="activity-title-row">
                        <div class="activity-title-content">
                            <input type="checkbox" class="activity-checkbox">
                            <img [src]="setIconoTipo(task.tipo)" alt="">
                            <h3 class="activity-title">{{task.titulo}}</h3>
                        </div>
                        <div class="activity-actions">
                            <button class="action-btn"><img src="assets/svg/gear-icon.svg" alt=""></button>
                             <button class="action-btn" (click)="toggle(task.tarea_id)">
                                <img 
                                    src="assets/svg/arrow-down-black.svg" 
                                    [class.rotated]="expanded[task.tarea_id]" 
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>

                    <div class="activity-description" *ngIf="expanded[task.tarea_id]">
                        <div class="description-label">Descripción:</div>
                        <p class="description-text">
                            {{task.comentarios}}
                        </p>
                    </div>
                </div>
            </article>
        </div>
    </section>

    <!-- Actividades Vencidas -->
    <section class="section">
        <div class="section-header">
            <h2 class="section-title">
                <img src="assets/svg/caution-icon.svg" alt="">
                Actividades vencidas
            </h2>
            <span class="chevron" (click)="toggleSection('vencidas')">
                <img src="assets/svg/arrow-down-black.svg"
                    [class.rotated]="sectionExpanded.vencidas"
                    alt="">
            </span>
        </div>
        <div *ngIf="t_vencidas.length === 0"><h4>No hay actividades vencidas</h4></div>

        <div class="timeline" *ngIf="sectionExpanded.vencidas">
            <article class="activity-item" *ngFor="let task of t_vencidas">
                <div class="activity-header">
                    <div class="activity-meta">
                        <span class="activity-date">{{(task.fecha_vencimiento | date:'d MMMM y':'':'es') | titlecase}}</span>
                        <a href="#" class="activity-assignee">
                            <img src="assets/svg/usert-icon.svg" alt="">
                            {{ task.ejecutivo.nombre }} {{ task.ejecutivo.apellido }}
                        </a>
                    </div>
                    <span class="activity-status status-pendiente">{{task.estado}}</span>
                </div>

                <div class="activity-card">
                    <div class="activity-title-row">
                        <div class="activity-title-content">
                            <input type="checkbox" class="activity-checkbox">
                            <img src="assets/svg/event-icon.svg" alt="">
                            <h3 class="activity-title">{{task.titulo}}</h3>
                        </div>
                        <div class="activity-actions">
                            <button class="action-btn"><img src="assets/svg/gear-icon.svg" alt=""></button>
                             <button class="action-btn" (click)="toggle(task.tarea_id)">
                                <img 
                                    src="assets/svg/arrow-down-black.svg" 
                                    [class.rotated]="expanded[task.tarea_id]" 
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>

                    <div class="activity-description" *ngIf="expanded[task.tarea_id]">
                        <div class="description-label">Descripción:</div>
                        <p class="description-text">
                            {{task.comentarios}}
                        </p>
                    </div>
                </div>
            </article>
        </div>
    </section>

    <!-- Actividades Realizadas -->
    <section class="section">
        <div class="section-header">
            <h2 class="section-title">
                <span class="section-icon">✓</span>
                Actividades realizadas
            </h2>
            <span class="chevron" (click)="toggleSection('realizadas')">
                <img src="assets/svg/arrow-down-black.svg"
                    [class.rotated]="sectionExpanded.realizadas"
                    alt="">
            </span>
        </div>
        <div *ngIf="t_vencidas.length === 0"><h4>No hay actividades realizadas</h4></div>

        <div class="timeline" *ngIf="sectionExpanded.realizadas">
            <article class="activity-item" *ngFor="let task of t_realizadas">
                <div class="activity-header">
                    <div class="activity-meta">
                        <span class="activity-date">{{(task.fecha_vencimiento | date:'d MMMM y':'':'es') | titlecase}}</span>
                        <a href="#" class="activity-assignee">
                            <img src="assets/svg/usert-icon.svg" alt="">
                            {{ task.ejecutivo.nombre }} {{ task.ejecutivo.apellido }}
                        </a>
                    </div>
                    <span class="activity-status status-pendiente">{{task.estado}}</span>
                </div>

                <div class="activity-card">
                    <div class="activity-title-row">
                        <div class="activity-title-content">
                            <input type="checkbox" class="activity-checkbox">
                            <img src="assets/svg/event-icon.svg" alt="">
                            <h3 class="activity-title">{{task.titulo}}</h3>
                        </div>
                        <div class="activity-actions">
                            <button class="action-btn"><img src="assets/svg/gear-icon.svg" alt=""></button>
                             <button class="action-btn" (click)="toggle(task.tarea_id)">
                                <img 
                                    src="assets/svg/arrow-down-black.svg" 
                                    [class.rotated]="expanded[task.tarea_id]" 
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>

                    <div class="activity-description" *ngIf="expanded[task.tarea_id]">
                        <div class="description-label">Descripción:</div>
                        <p class="description-text">
                            {{task.comentarios}}
                        </p>
                    </div>
                </div>
            </article>
        </div>
    </section>
</div>